/** Brief 12, the Holatlar canvases: banners, push, a failed send, the offline frame. */
export const uzB12Holatlar = {
  "hol.credits.buy": "Kredit sotib olish",
  "hol.credits.out": "AI kreditlari tugadi · AI to'xtadi, suhbatlar operatorlarga o'tdi. CRM ishlashda davom etadi.",
  "hol.credits.full": "AI kreditlar {credits} qoldi. O'rtacha sarf bo'yicha {days} kunga yetadi.",
  "hol.credits.short3": "AI kreditlari tez orada tugaydi. Egaga xabar berildi.",
  "hol.credits.short1": "AI ertaga to'xtashi mumkin.",
  "hol.credits.thread": "AI kreditlari tugadi · bu suhbatga siz javob berasiz.",
  "hol.channel.down": "{label}: {status}. Bu akkauntga kelgan xabarlar olinmayapti.",
  "hol.channel.reconnect": "Qayta ulash",
  "hol.offline.title": "Internet yo'q",
  "hol.offline.text": "Yozgan xabarlaringiz saqlanadi va aloqa tiklanganda yuboriladi.",
  "hol.offline.queued": "Internet yo'q. Xabar saqlandi, aloqa tiklanishi bilan yuboriladi.",
  "hol.push.title": "Bildirishnomalarga ruxsat bering",
  "hol.push.subtitle": "Yangi suhbat va SLA haqida darhol bilasiz",
  "hol.push.scope": "Faqat sizga biriktirilgan suhbatlar, AI handofflari va SLA ogohlantirishlari. Tinch soatlarda yuborilmaydi.",
  "hol.push.allow": "Ruxsat berish",
  "hol.push.later": "Keyinroq",
  "hol.push.failed": "Bu qurilmada bildirishnomani yoqib bo'lmadi.",
  "hol.push.device": "Bu qurilma",
  "hol.push.on": "Bildirishnomalar yoqilgan.",
  "hol.push.enable": "Yoqish",
  "hol.push.deniedTitle": "Bildirishnomalar o'chiq.",
  "hol.push.deniedText": "Brauzer sozlamalarida Kapitan uchun ruxsat bering yoki Profil – Telegram'ni ulang.",
  "hol.push.connectTelegram": "Telegram'ni ulash",
  "hol.failed.count": "{count} ta xabar yuborilmadi.",
  "hol.failed.reason": "{channel} xabarni qabul qilmadi. Xabarlar navbatda qoldi.",
  "hol.failed.retry": "Qayta yuborish",
  "hol.failed.retried": "Xabarlar qayta navbatga qo'yildi.",
  "hol.failed.retryError": "Qayta yuborib bo'lmadi.",
  "hol.thread.heldBy": "Bu suhbat {name}da. Olib qo'yish uchun menejerga yozing.",
  "hol.match.title": "Bu mijoz boshqa kartochkada ham bo'lishi mumkin · {name}.",
  "hol.match.compare": "Solishtirish",
  "hol.match.different": "Bu boshqa odam",
  "hol.match.dialog": "Mijozlarni solishtirish",
  "hol.match.reason": "Moslik sababi: {reason}",
  "hol.match.diff": "Sariq fon · farq qiladigan maydonlar",
  "hol.match.name": "Ism",
  "hol.match.phone": "Telefon",
  "hol.match.trips": "Sayohatlar",
  "hol.match.merge": "Birlashtirish",
  "hol.match.merged": "Mijozlar birlashtirildi. Ajratish orqali qaytarish mumkin.",
  "hol.match.failed": "Birlashtirib bo'lmadi.",
  "hol.match.dismissFailed": "Saqlab bo'lmadi.",
  "hol.match.loadFailed": "Solishtirib bo'lmadi.",
  "hol.history.running": "{label}: tarix ko'chirilmoqda · {percent}%",
  "hol.thread.aiOff": "AI o'chiq · operator javob beradi. Qoralama ko'rsatilmaydi.",
} as const;
